import DownloadsPage from "./DownloadsPage";

export default DownloadsPage;
